import {ReactElement} from "react";
import {StyledBoxColumn} from "@/shared/StyledComponents";
import {Typography} from "@mui/material";
import {StoredDataFileUploadFragment} from "@/shared/StoredDateFileUploadFragment";
import {DIVIDER, PD_LG} from "@/shared/dimens";
import {DesktopFile} from "@/shared/files";

export function MediaImageUploadFragment(props: {
  value: string,
  setValue: (url: string, file?: DesktopFile) => void
}): ReactElement {
  return <StyledBoxColumn style={{padding: PD_LG}}>
    <Typography variant="h6">Upload</Typography>
    <StoredDataFileUploadFragment
      style={{border: DIVIDER}}
      isDialog={true}
      mimeTypes={["image/*"]}
      storedDataSource={"vantage/media"}
      initialUrls={props.value ? [props.value] : undefined}
      onUploadDone={(urls: string[], files?: DesktopFile[]) => {
        props.setValue(urls[0], files?.[0]);
      }}/>
  </StyledBoxColumn>
}
